<template>
  <b-modal
    centered
    ref="codes-referred-modal"
    size="lg"
    hide-footer
    hide-header
  >
    <b-container>
      <b-row>
        <b-col>
          <h3 class="text-center">Códigos y referidos</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-container>
            <b-row>
              <b-col> Tienes un código? Ingrésalo aquí! </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-input
                  v-model="code"
                  type="text"
                  placeholder="Ingresa tu código"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button @click="applyCode"> Aplicar! </b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col>
          <b-container v-if="canRefer">
            <b-row>
              <b-col> Alguien te invitó? Ingresa su correo aquí! </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-input
                  v-model="email"
                  type="text"
                  placeholder="Ingresa el correo"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button @click="referUser"> Referir! </b-button>
              </b-col>
            </b-row>
          </b-container>
          <b-container v-else>
            <b-row>
              <b-col> Ya referiste a una persona! </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import userService from "@/services/userService";

export default {
  data() {
    return {
      code: "",
      email: "",
      canRefer: true,
    };
  },
  watch: {
    "$store.state.login.codesReferredModal"() {
      this.open();
    },
  },
  methods: {
    open() {
      this.code = "";
      this.email = "";
      this.checkReferred();
      this.$refs["codes-referred-modal"].show();
    },
    checkReferred() {
      userService.checkReferred().then((data) => {
        this.canRefer = data.can_refer;
      });
    },
    applyCode() {
      if (!this.code) {
        this.$toasted.error("Por favor ingresa un código.");
        return;
      }
      userService.redeemPromotionalCode({ code: this.code }).then(
        (data) => {
          this.$toasted.success(data.message);
          this.code = "";
        },
        (error) => {
          this.$toasted.error(
            (error.response && error.response.data.message) ||
              "Error al canjear el código"
          );
        }
      );
    },
    referUser() {
      if (this.email) {
        userService.referUser({ email: this.email }).then(
          (data) => {
            this.$toasted.success(data.message);
            this.canRefer = false;
          },
          (error) => {
            this.$toasted.error(
              error.response.data.message || "Error al referir usuario"
            );
          }
        );
      } else {
        this.$toasted.error("Por favor ingresa un correo válido.");
      }
    },
  },
};
</script>

<style lang="scss"></style>
